import { render, staticRenderFns } from "./voice-input.vue?vue&type=template&id=778bf51a&"
import script from "./voice-input.vue?vue&type=script&lang=js&"
export * from "./voice-input.vue?vue&type=script&lang=js&"
import style0 from "./voice-input.vue?vue&type=style&index=0&id=778bf51a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports